import { GerarReembolsoListComp } from 'pages/financeiro/reembolso/gerar-reembolso/components/GerarReembolsoList';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { GerarReembolsoProvider } from 'pages/financeiro/reembolso/gerar-reembolso/contexts';

export function GerarReembolsoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_REEMBOLSO_GERAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <GerarReembolsoProvider>
                <GerarReembolsoListComp />
            </GerarReembolsoProvider>
        </ListagemProvider>
    );
}
